import punycode from 'punycode'

const decodeUnicode = (str) => punycode.ucs2.decode(str) // func to handle unicode characters

const regex = /(?:\r\n|\r|\n)/g  // new line, carriage return, line feed

export default (editorState) => {
  const plainText = editorState.getCurrentContent().getPlainText('')
  const cleanString = plainText.replace(regex, '').trim()  // replace above characters w/ nothing
  return decodeUnicode(cleanString).length
}
